/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Typography,
  FormLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Tooltip,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DownloadingIcon from '@mui/icons-material/Downloading';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useParams, Link, useNavigate } from 'react-router-dom';
import PaymentAction from '../../store/actions/PaymentAction';
import Loader from '../../utils/errorPages/Loader';
// import Logo from '../../assets/images/logo_image.png';
import ManualPayment from './payment_modal';
import useHasPermission from '../../utils/useHasPermission';
import { paymentRequest, update } from '../../utils/constants';

function PaymentRequestView() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStatus, seModalStatus] = useState('');
  const [payInfo, setPayInfo] = useState({});
  const { code } = useParams();
  const { paymentItemData, isLoading } = useSelector((state) => state.payment);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { REACT_APP_API_URL } = process.env;

  useEffect(() => {
    dispatch(PaymentAction.getItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    if (paymentItemData) {
      setPayInfo(paymentItemData);
    }
  }, [paymentItemData]);

  // useEffect(() => {
  //   if (clientItemData && clientItemData?.data) {
  //     setClientInfo(clientItemData.data);
  //   }
  // }, [clientItemData]);

  // useEffect(() => {
  //   if (clientInfo) {
  //     setPayInfo((prevValues) => ({
  //       ...prevValues,
  //       primary_email: clientInfo?.email || '',
  //       department_id: clientInfo?.departments || []
  //     }));
  //   }
  // }, [clientInfo]);
  // const handleEditorOnChange = (data) => {
  //   setMailContent(data);
  // };

  const status = payInfo?.status;

  return (
    <>
      {isLoading ? <Loader /> : ''}
      <Box sx={{ mb: 3 }} className="cardWrapper viewPaymentRequest">
        <div className="pageTitleWrap">
          <Stack
            direction="row"
            sx={{ mb: 2 }}
            spacing={6}
            alignItems="center"
            justifyContent="flex-start"
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography
                sx={{
                  mb: '0 !important'
                }}
                variant="text"
                component={Link}
                to="/payment-request"
              >
                Payment Request
              </Typography>
              <Typography sx={{ mb: '0 !important' }} component="h2" variant="h2">
                / View
              </Typography>
            </Stack>
            <Button
              type="button"
              className="cancel__btn"
              // fullWidth
              sx={{ p: '6px 12px !important', minWidth: 'auto !important' }}
              variant="contained"
              color="primary"
              size="medium"
              onClick={() => {
                navigate(`/payment-request`);
              }}
            >
              Back
            </Button>
          </Stack>
        </div>
        <Grid container spacing={2}>
          <Grid item md={12} lg={12} xl={8}>
            <Card>
              <CardHeader title="Payment Details" />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item md={8} lg={8} xl={7}>
                    <Box className="velanAddressInfo">
                      {payInfo?.address?.logo && (
                        <img
                          src={`${REACT_APP_API_URL}/${payInfo.address.logo}`}
                          alt="Velan Logo"
                          width="180"
                          height="45"
                        />
                      )}
                      <Typography className="" component="p" variant="body1">
                        {payInfo?.address?.full_address}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={4} lg={4} xl={5}>
                    <Typography variant="body1" component="p">
                      <FormLabel sx={{ mr: 1 }}>Invoice Number :</FormLabel>
                      {payInfo?.invoice_number || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Invoice Date :</FormLabel>
                      {payInfo?.invoice_date || ''}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ mt: 2 }}>
              <CardHeader title="Billing Details" />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item md={8} lg={8} xl={7}>
                    <Typography variant="body1" component="p">
                      <b>{payInfo?.client?.name || ''}</b>
                    </Typography>
                    <Typography variant="body1" component="p">
                      {payInfo?.company?.name || ''}
                    </Typography>
                    {payInfo?.client ? (
                      <Typography className="" component="p" variant="body1">
                        {payInfo?.client?.address_1} <br />
                        {payInfo?.client?.address_2}
                        {payInfo?.client?.address_2 && <br />}
                        {payInfo?.client?.city} <br />
                        {`${payInfo?.client?.state && payInfo?.client?.state?.name}, ${
                          payInfo?.client?.country && payInfo?.client?.country?.name
                        } - ${payInfo?.client?.postal_code}`}
                      </Typography>
                    ) : (
                      ''
                    )}
                    <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                      {payInfo?.primary_email || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mb: 2 }}>
                      {payInfo?.invoice_email &&
                        payInfo?.invoice_email.map((item) => item).join(', ')}
                    </Typography>
                  </Grid>
                  <Grid item md={4} lg={4} xl={5}>
                    <Typography variant="body1" component="p" sx={{ mb: 1 }}>
                      <FormLabel sx={{ mr: 1 }}> Payment Request type :</FormLabel>
                      {payInfo?.paymentRequestType?.type || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mb: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Client Approval Date :</FormLabel>
                      {payInfo?.client_approval_date || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mb: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Due Date :</FormLabel>
                      {payInfo?.due_date || ''}
                    </Typography>
                    <Typography variant="body1" component="p" sx={{ mb: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>
                        {payInfo?.purchase_type === 'po_number'
                          ? 'PO Number'
                          : 'Contract Date' || ''}
                        :
                      </FormLabel>
                      {payInfo?.purchase_value || ''}
                    </Typography>
                    <Typography variant="body1" component="div" sx={{ mb: 1 }}>
                      <FormLabel sx={{ mr: 1 }}>Departments: </FormLabel>
                      {payInfo?.departments &&
                        payInfo?.departments.map((item) => {
                          return (
                            <Tooltip title={item.name} arrow key={item._id}>
                              <Chip
                                sx={{
                                  p: 0.25,
                                  pt: 0.5,
                                  mr: 0.5,
                                  mb: 0.5,
                                  width: 'auto',
                                  height: 'auto',
                                  '.MuiChip-label': {
                                    fontSize: '13px',
                                    letterSpacing: '0.5px',
                                    opacity: 1
                                  }
                                }}
                                label={item.name}
                                size="small"
                                color="primary"
                              />
                            </Tooltip>
                          );
                        })}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider />
                <Grid container spacing={2} sx={{ mt: 1 }}>
                  <Grid item md={8} lg={8} xl={7}>
                    <Typography variant="body1" component="p">
                      <FormLabel sx={{ mb: 1, mr: 1, display: 'block' }}>Invoice PDF: </FormLabel>
                      <Chip
                        sx={{
                          p: 0.25,
                          pt: 0.5,
                          mr: 0.5,
                          width: 'auto',
                          height: 'auto',
                          '.MuiChip-label': {
                            fontSize: '13px',
                            letterSpacing: '0.5px',
                            opacity: 1
                          }
                        }}
                        component={Link}
                        target="_blank"
                        clickable
                        to={`${REACT_APP_API_URL}/${payInfo.pdf_filename}`}
                        icon={<PictureAsPdfIcon />}
                        label="Download"
                        variant="outlined"
                        size="medium"
                        color="primary"
                      />
                    </Typography>
                  </Grid>
                  <Grid item md={4} lg={4} xl={5}>
                    {payInfo.timeSheet && payInfo.timeSheet.length > 0 ? (
                      <Box>
                        <FormLabel sx={{ mr: 1 }}>Time Sheets: </FormLabel>
                        <List>
                          {payInfo.timeSheet &&
                            payInfo?.timeSheet.map((item, index) => {
                              const lastUnderscoreIndex = item.time_sheet.lastIndexOf('_');
                              const fileName = item.time_sheet.substring(lastUnderscoreIndex + 1);
                              return (
                                <ListItem
                                  sx={{
                                    bgcolor: 'primary.main',
                                    color: '#fff',
                                    borderRadius: 1,
                                    mb: 1,
                                    p: '4px 8px'
                                  }}
                                  key={index}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="timeSheet"
                                      component={Link}
                                      to={`${REACT_APP_API_URL}/${item.time_sheet}`}
                                      target="_blank"
                                    >
                                      <DownloadingIcon sx={{ color: '#fff' }} />
                                    </IconButton>
                                  }
                                >
                                  <ListItemText
                                    sx={{
                                      '.MuiTypography-root': {
                                        fontSize: '13px',
                                        fontWeight: '700'
                                      }
                                    }}
                                    primary={fileName}
                                  />
                                </ListItem>
                              );
                            })}
                        </List>
                      </Box>
                    ) : (
                      ''
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ mt: 2 }}>
              <CardHeader title="Invoice Details" />
              <CardContent>
                <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell component="th">Service From</TableCell>
                          <TableCell component="th">Service To</TableCell>
                          <TableCell component="th">Description</TableCell>
                          <TableCell component="th">Qty</TableCell>
                          <TableCell component="th">UOM</TableCell>
                          <TableCell component="th">Rate</TableCell>
                          <TableCell component="th">Amount</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {payInfo?.details &&
                          payInfo?.details.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                {item?.services.map((serviceitem, i) => {
                                  return (
                                    <TableRow key={`${index}-${i}`}>
                                      {i === 0 ? (
                                        <>
                                          <TableCell>{item.services_from}</TableCell>
                                          <TableCell>{item.services_to}</TableCell>
                                        </>
                                      ) : (
                                        <>
                                          <TableCell>{item.services_from} </TableCell>
                                          <TableCell>{item.services_to}</TableCell>
                                        </>
                                      )}
                                      <TableCell component="td">
                                        {serviceitem.service_description}
                                      </TableCell>
                                      <TableCell component="td">{serviceitem.quantity}</TableCell>
                                      <TableCell component="td">
                                        {serviceitem?.unit_measurement_id?.name}
                                      </TableCell>
                                      <TableCell component="td">{serviceitem.rate}</TableCell>
                                      <TableCell component="td">
                                        {`${payInfo?.currency?.short_name} ${serviceitem.amount}`}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </React.Fragment>
                            );
                          })}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TableCell colSpan="5"> </TableCell>
                          <TableCell component="th">Total</TableCell>
                          <TableCell align="left" component="th">
                            {`${payInfo?.currency?.short_name} ${payInfo?.grand_total}`}
                          </TableCell>
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </Box>
              </CardContent>
            </Card>
            {payInfo?.manual_payment && payInfo?.manual_payment?.data && (
              <Card sx={{ mt: 2 }}>
                <CardHeader title="Manual Payment" />
                <CardContent>
                  <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell component="th">Invoice Number</TableCell>
                            <TableCell component="th">Payment Getaway</TableCell>
                            <TableCell component="th">Payment Type</TableCell>
                            <TableCell component="th">Status</TableCell>
                            <TableCell component="th">Transaction ID</TableCell>
                            <TableCell component="th">Amount</TableCell>
                            <TableCell component="th">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {payInfo?.manual_payment?.data.map((item, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell>{item.invoice_number} </TableCell>
                                <TableCell>{item.payment_gateway}</TableCell>
                                <TableCell component="td">{item.payment_type_name}</TableCell>
                                <TableCell component="td">{item.status_name}</TableCell>
                                <TableCell component="td">{item.transaction_id}</TableCell>
                                <TableCell component="td">
                                  {`${payInfo?.currency?.short_name} ${item.amount}`}
                                </TableCell>
                                <TableCell component="td">
                                  <IconButton
                                    aria-label="View"
                                    component={Link}
                                    to={`/transaction/manual/view/${item._id}`}
                                    target="_blank"
                                  >
                                    <i className="icon-view" />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                        <TableFooter sx={{ bgcolor: '#e6efff' }}>
                          <TableRow>
                            <TableCell colSpan="4" sx={{ border: 'none' }} />
                            <TableCell component="th">Total</TableCell>
                            <TableCell align="left" component="th">
                              {`${payInfo?.currency?.short_name} ${payInfo?.manual_payment?.total}`}
                            </TableCell>
                            <TableCell sx={{ border: 'none' }} />
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan="4" sx={{ border: 'none' }} />
                            <TableCell component="th">Paid</TableCell>
                            <TableCell align="left" component="th">
                              {`${payInfo?.currency?.short_name} ${payInfo?.manual_payment?.paid}`}
                            </TableCell>
                            <TableCell sx={{ border: 'none' }} />
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan="4" sx={{ border: 'none' }} />
                            <TableCell component="th">Balance</TableCell>
                            <TableCell align="left" component="th">
                              {`${payInfo?.currency?.short_name} ${payInfo?.manual_payment?.balance}`}
                            </TableCell>
                            <TableCell sx={{ border: 'none' }} />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </Box>
                </CardContent>
              </Card>
            )}
          </Grid>
          <Grid item md={12} lg={12} xl={4}>
            <Card>
              <CardHeader title="Currency and Payments" />
              <CardContent>
                <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                  <FormLabel sx={{ mr: 1 }}>Currency:</FormLabel>
                  {payInfo?.currency?.short_name || ''}
                </Typography>
                <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                  <FormLabel sx={{ mr: 1 }}>Payment Method:</FormLabel>
                  {payInfo?.paymentMethod &&
                    payInfo?.paymentMethod.map((item) => item.name).join(', ')}
                </Typography>
                <Typography variant="body1" component="p" sx={{ mt: 1 }}>
                  <FormLabel sx={{ mr: 1 }}>Schedule Date:</FormLabel>
                  {payInfo?.scheduled_at || ''}
                </Typography>
                <Typography variant="body1" component="div" sx={{ mt: 1 }}>
                  <FormLabel sx={{ mr: 1 }}>Status:</FormLabel>
                  {payInfo?.status_name ? (
                    <Chip
                      sx={{
                        p: 0.25,
                        pt: 0.5,
                        mr: 0.5,
                        width: 'auto',
                        height: 'auto',
                        '.MuiChip-label': {
                          fontSize: '13px',
                          letterSpacing: '0.5px',
                          opacity: 1
                        }
                      }}
                      color={payInfo?.status_name.toLowerCase().replace(/\s+/g, '')}
                      label={payInfo?.status_name || ''}
                    />
                  ) : (
                    ''
                  )}
                  {/* <Stack spacing={2} direction="row">
                    <Chip label="Draft" color="draft" />
                    <Chip label="Paid" color="paid" />
                    <Chip label="Failed" color="failed" />
                    <Chip label="Overdue" color="overdue" />
                    <Chip label="Canceled" color="canceled" />
                    <Chip label="Feedback" color="feedback" />
                    <Chip label="Pending" color="pending" />
                    <Chip label="Verify" color="verify" />
                    <Chip label="Partial Payment" color="partialpayment" />
                    <Chip label="Write off" color="writeoff" />
                  </Stack> */}
                </Typography>
              </CardContent>
            </Card>
            {payInfo?.transaction ? (
              <Card sx={{ mt: 2 }}>
                <CardHeader title="Transaction Details" />
                <CardContent>
                  <Box sx={{ bgcolor: 'white' }} className="dataTable__wrap">
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableCell colSpan={2} component="th">
                            Payment Details
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell component="th">Payment Gateway</TableCell>
                            <TableCell component="td" sx={{ textTransform: 'capitalize' }}>
                              {payInfo?.transaction?.payment_gateway || ''}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th">Transaction ID</TableCell>
                            <TableCell component="td">
                              {payInfo?.transaction?.transaction_id || ''}
                            </TableCell>
                          </TableRow>
                          {payInfo?.transaction?.card_number !== null ? (
                            <TableRow>
                              <TableCell component="th">Card Number</TableCell>
                              <TableCell component="td">
                                {payInfo?.transaction?.card_number || ''}
                              </TableCell>
                            </TableRow>
                          ) : (
                            ''
                          )}
                          <TableRow>
                            <TableCell component="th">Amount</TableCell>
                            <TableCell component="td">
                              {`${payInfo?.transaction?.currency}
                              ${payInfo?.transaction?.amount || ''}`}
                            </TableCell>
                          </TableRow>
                          {payInfo?.transaction?.paypal_capture_id !== null ? (
                            <TableRow>
                              <TableCell component="th">Paypal Capture ID</TableCell>
                              <TableCell component="td">
                                {payInfo?.transaction?.paypal_capture_id || ''}
                              </TableCell>
                            </TableRow>
                          ) : (
                            ''
                          )}
                        </TableBody>
                        <TableHead>
                          <TableCell colSpan={2} component="th">
                            Status Details
                          </TableCell>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell component="th">IP Address</TableCell>
                            <TableCell component="td">
                              {payInfo?.transaction?.ip_address || ''}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th">Paid Date</TableCell>
                            <TableCell component="td">
                              {payInfo?.transaction?._created_at}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell component="th">Payment Recevied Status</TableCell>
                            <TableCell component="td">
                              {payInfo?.transaction?.payment_transaction_status || ''}
                            </TableCell>
                          </TableRow>
                          {/* <TableRow>
                            <TableCell component="th">Transaction Status</TableCell>
                            <TableCell component="td">
                              <Chip color="success" label={payInfo?.transaction?.status || ''} />
                            </TableCell>
                          </TableRow> */}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </CardContent>
              </Card>
            ) : (
              ''
            )}
            {status != null && (
              <Card sx={{ mt: 2 }}>
                <CardActions
                  sx={(theme) => ({
                    justifyContent: 'center',
                    p: 3,
                    [theme.breakpoints.up('xl')]: {
                      flexDirection: 'column'
                    }
                  })}
                >
                  {useHasPermission(paymentRequest, update) && ![16, 6, 5, 17].includes(status) && (
                    <>
                      <Button
                        type="button"
                        sx={{ mt: 2, ml: 1 }}
                        variant="contained"
                        color="partialpayment"
                        size="medium"
                        onClick={() => {
                          setModalOpen(true);
                          seModalStatus('manual');
                        }}
                      >
                        Wire Transfer
                      </Button>

                      <Button
                        type="button"
                        sx={{ mt: 2 }}
                        variant="contained"
                        color="writeoff"
                        size="medium"
                        onClick={() => {
                          setModalOpen(true);
                          seModalStatus('writeoff');
                        }}
                      >
                        Write Off Payment
                      </Button>
                    </>
                  )}

                  {status === 17 && (
                    <Button
                      type="button"
                      sx={{ mt: 2 }}
                      variant="contained"
                      fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        dispatch(PaymentAction.getScheduleCancel(code, navigate));
                      }}
                    >
                      Cancel Schedule
                    </Button>
                  )}
                </CardActions>
              </Card>
            )}
          </Grid>
        </Grid>
        {modalOpen === true ? (
          <ManualPayment
            itemId={code}
            openmodal={modalOpen}
            modalstatus={modalStatus}
            onCloseModal={() => setModalOpen(false)}
          />
        ) : (
          ''
        )}
      </Box>
    </>
  );
}
export default PaymentRequestView;
